function showCartNotification(product, cartItemCount) {
  // Populate product image
  $('#cart-notification-product .cart-notification-product__image img')
    .attr('src', product.image)
    .attr('alt', product.title);

  // Update product title
  $('#cart-notification-product .cart-notification-product__name').text(product.title);

  // Clear old variant options
  $('#cart-notification-product dl').empty();

  // Dynamically add option labels and values from product.options_with_values
  if (product.options_with_values && product.options_with_values.length > 0) {
    product.options_with_values.forEach(option => {
      $('#cart-notification-product dl').append(`
        <div class="product-option">
          <dt>${option.name}:</dt>
          <dd>${option.value}</dd>
        </div>
      `);
    });
  }

  // Update cart item count
  $('#cart-notification-button .cart_items_count').html(`${cartItemCount}`);
  $('#CartBubble').addClass(`cart-link__bubble--visible`);

  // Show notification with 'active' class
  const $notification = $('#cart-notification');
  $notification.addClass('active').fadeIn();

  /*
  setTimeout(() => {
    $notification.fadeOut(300, () => {
      $notification.removeClass('active');
    });
  }, 3000);
  */
}

// Close button logic
$(document).on('click', '.cart-notification__close', function () {
  $('#cart-notification').fadeOut().removeClass('active');
});
$(document).on('click', '.continue_shipping_btn', function () {
  $('#cart-notification').fadeOut().removeClass('active');
});
 
$('form.product-single__form').on('submit', function (e) {
  e.preventDefault();
  const $form = $(this);
  const formData = new FormData($form[0]);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Accept': 'application/json' },
    body: formData
  })
    .then(res => res.json())
    .then(addedProduct => {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          showCartNotification(addedProduct, cart.item_count);
        });
    });
});